<template>
  <el-tree
    ref="tree"
    class="cy-common-left-nav"
    node-key="id"
    :data="navData"
    :props="defaultProps"
    :empty-text="emptyText"
    :indent="5"
    accordion
    :default-expanded-keys="expandId"
    @node-click="handleNodeClick"
  >
    <div
      slot-scope="scope"
      :class="{ 'is-leaf_label': scope.data.level === 2 }"
    >
      <slot
        :node="scope.node"
        :data="scope.data"
      >
        <template>
          <span
            :title="scope.data.name"
            class="el-tree-node__label"
          >
            {{ scope.data.name }}
          </span>
        </template>
      </slot>
    </div>
  </el-tree>
</template>

<script>
export default {
  name: 'JlxkNav',
  props: {
    navData: {
      type: Array,
      default: () => []
    },
    emptyText: {
      type: String,
      default: ''
    },
    expandId: {
      type: Array,
      default: () => []
    },
    firstLevelView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentKey: ''
    }
  },
  computed: {},
  methods: {
    handleNodeClick(data, node) {
      if (data.level === 1) {
        if (this.firstLevelView) {
          this.currentKey = data.id
          let result = {
            id: data.id,
            name: data.name
          }
          this.$emit('handleNodeClick', result)
          return false
        }
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.currentKey)
        })
        return false
      }
      this.currentKey = data.id
      let result = {
        parentId: node.parent.data.id,
        parentname: node.parent.data.name,
        parentCode: node.parent.data.code,
        id: data.id,
        name: data.name
      }
      this.$emit('handleNodeClick', result)
    }
  }
}
</script>

<style lang="scss" scoped>
.cy-common-left-nav {
  position: fixed;
  width: 140px;
  height: calc(100vh - 100px);
  margin: 0 12px 0 0;
  padding: 4px 0 10px;
  flex-shrink: 0;
  background-size: cover;
  overflow: auto;
  background: url("~@assets/imgs/leftBar-bg.png") no-repeat;
  background-color: #3E7DF1;
  /deep/ .el-tree-node {
    &__content {
      height: 40px;
      color: #fff;
      border: none;
      background-color: transparent;
    }
    &__children {
      .el-tree-node__expand-icon {
        display: flex;
        background: transparent;
        justify-content: center;
        align-items: center;
        &::before {
          display: block;
          width: 6px;
          height: 6px;
          border: 1px solid #666666;
          border-radius: 50%;
        }
      }
      .el-tree-node__label {
        color: #666;
      }
    }
    &__expand-icon {
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0 7px 0 12px;
      flex-shrink: 0;
      background: url("~@assets/imgs/jlxk/editor-bg-normal.png") no-repeat 0 0;
      &::before {
        display: none;
      }
      &.expanded {
        transform: rotate(0deg);
        background-image: url("~@assets/imgs/jlxk/editor-bg-active.png");
      }
      &.is-leaf {
        background: none;
      }
    }
    &__label {
      padding-right: 10px;
      max-height: 32px;
      overflow: hidden;
      white-space: normal;
      line-height: 16px;
      font-size: 13px;
    }
    &.is-focusable {
      background-color: transparent;
    }
    &.is-expanded {
      > .el-tree-node__content {
        background-color: rgba(255, 255, 255, 0.85);
        > div {
          > .el-tree-node__label {
            color: #555;
          }
        }
      }
      .el-tree-node__children {
        background-color: rgba(255, 255, 255, 0.5);
        .el-tree-node.is-current {
          .el-tree-node__expand-icon {
            &::before {
              border-color: #3780f7;
              background: #3780f7;
            }
          }
          .el-tree-node__label {
            color: #3780f7;
          }
        }
      }
    }
  }
  /deep/ .el-tree__empty-text {
    font-size: 13px;
    color: #fff;
    top: 50px;
  }
}
</style>
